var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIconPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16292",
    "data-name": "Rectangle 16292",
    width: 7.264,
    height: 9.362,
    fill: "#f54e30"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16557",
    "data-name": "Group 16557",
    transform: "translate(0.028 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16413",
    "data-name": "Group 16413",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 12.5,
    cy: 13,
    rx: 12.5,
    ry: 13,
    transform: "translate(-0.028 0)",
    fill: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16415",
    "data-name": "Group 16415",
    transform: "translate(8.789 7.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15531",
    "data-name": "Group 15531",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41159",
    "data-name": "Path 41159",
    d: "M13.916,56.993h6.237c0,.034,0,.064,0,.093q0,3.048,0,6.1a1.037,1.037,0,0,1-.807,1.057,1.169,1.169,0,0,1-.271.028q-2.036,0-4.073,0a1.042,1.042,0,0,1-1.09-1.091q0-1.764,0-3.528V56.993Z",
    transform: "translate(-13.406 -54.906)",
    fill: "#f54e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41160",
    "data-name": "Path 41160",
    d: "M7.264.518V1.553H0V.518H.1c.539,0,1.078,0,1.617,0A.2.2,0,0,0,1.879.453q.2-.2.4-.4A.189.189,0,0,1,2.4,0Q3.63,0,4.863,0A.189.189,0,0,1,4.98.052c.13.123.258.25.381.381A.254.254,0,0,0,5.567.52c.527,0,1.053,0,1.58,0Z",
    transform: "translate(0 0)",
    fill: "#f54e30"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconPink);
export default __webpack_public_path__ + "static/media/delete_icon_pink.a05e5b83e5ae2d454be852b143f5ebd8.svg";
export { ForwardRef as ReactComponent };